// src/components/auth/ProfileCompletionGuard.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

/**
 * ProfileCompletionGuard ensures therapists with incomplete profiles
 * are redirected to the /profile page to complete their information
 */
const ProfileCompletionGuard = ({ children }) => {
  const { profileComplete } = useAuth();
  const location = useLocation();

  // If profile is incomplete and not already on the profile page, redirect to /profile
  if (!profileComplete && location.pathname !== "/profile") {
    return <Navigate to="/profile" replace />;
  }

  return children;
};

export default ProfileCompletionGuard;
